import React from 'react'
import styled from 'styled-components'

import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import Link from '../Link'
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaGithub,
  FaYoutube,
  FaChevronRight,
  FaCalendarPlus,
  FaHandshake
} from 'react-icons/fa'
import ContactForm from './ContactForm'
import { CommercialContactForm } from './CommercialContactForm'
import { LanguageConsumer } from '../../state'

const Container = styled.div`
  display: flex;

  @media screen and (max-width: 900px) {
    display: block;
  }
`

const ContactDetails = styled.div`
  flex: 1.3;
  padding-right: 2rem;

  @media screen and (max-width: 900px) {
    text-align: center;
    padding-right: 0;
    padding-bottom: 4rem;
  }
`

const ContactFormContainer = styled.div`
  flex: 2.5;
  padding-left: 2rem;

  @media screen and (max-width: 900px) {
    padding-left: 0;
  }
`

const Address = styled.div``

const SocialLinks = styled.ul`
  list-style: none;
  margin: 0;

  li {
    display: inline-block;
    font-size: 3rem;
    padding: 4rem 2rem 0;

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      padding-right: 0;
    }

    a {
      color: ${({ theme }) => theme.colors.secondaryText};

      &:hover {
        color: ${({ theme }) => theme.colors.text};
      }
    }
  }

  @media screen and (max-width: 500px) {
    li {
      padding: 4rem 1rem 0;
      font-size: 2.6rem;
    }
  }
`

const Links = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    margin: 2rem 0;
    flex: 1 1 20%;
    @media (max-width: 959px) {
      flex: 1 1 50%;
    }
  }
  li,
  a {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
  }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .req-cta {
    max-height: 166px;
    margin: 2rem;
    padding: 4rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.4rem;
    display: flex;
    flex-direction: column;
    color: inherit;
    border: 1px solid transparent;
    .icon {
      font-size: 4rem;
    }
    &:hover {
      background: none;
      border: 1px solid rgba(255, 255, 255, 0.3);
    }
  }
`

export default ({ hubspot }) => (
  <LanguageConsumer>
    {({ lang }) => (
      <Query
        render={(content) => (
          <Layout>
            <Hero>
              <HeroTitle useH1>{content.title}</HeroTitle>
            </Hero>
            <Container>
              <ContactDetails>
                <h2>{content.office_address.title}</h2>
                <Address>
                  <p>{content.office_address.company_name}</p>
                  <p>{content.office_address.building}</p>
                  <p>{content.office_address.street}</p>
                  <p>{content.office_address.city}</p>
                </Address>
                <SocialLinks>
                  <li>
                    <Link
                      tracking={{ label: 'contact_page_twitter' }}
                      href={content.social_links.twitter}
                    >
                      <FaTwitter />
                    </Link>
                  </li>
                  <li>
                    <Link
                      tracking={{ label: 'contact_page_facebook' }}
                      href={content.social_links.facebook}
                    >
                      <FaFacebookF />
                    </Link>
                  </li>
                  <li>
                    <Link
                      tracking={{ label: 'contact_page_github' }}
                      href={content.social_links.github}
                    >
                      <FaGithub />
                    </Link>
                  </li>
                  <li>
                    <Link
                      tracking={{ label: 'contact_page_linkedin' }}
                      href={content.social_links.linkedin}
                    >
                      <FaLinkedinIn />
                    </Link>
                  </li>
                  <li>
                    <Link
                      tracking={{ label: 'contact_page_youtube' }}
                      href={content.social_links.youtube}
                    >
                      <FaYoutube />
                    </Link>
                  </li>
                </SocialLinks>
              </ContactDetails>
              <ContactFormContainer>
                {hubspot ? (
                  <CommercialContactForm
                    content={content.partnerships_form}
                    lang={lang}
                  />
                ) : (
                  <React.Fragment>
                    <p>
                      <em>{content.disclaimer}</em>
                    </p>
                    <Links>
                      <li>
                        <Link href="/contact-commercial" className="req-cta">
                          <div className="icon">
                            <FaHandshake />
                          </div>
                          <div>
                            {content.partnerships_link} <FaChevronRight />
                          </div>
                        </Link>
                      </li>
                      <li>
                        <a
                          href="https://forms.gle/fGsKwekjFbpNcHk27"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="req-cta"
                        >
                          <div className="icon">
                            <FaCalendarPlus />
                          </div>
                          <div>
                            {content.events_link}
                            <FaChevronRight />
                          </div>
                        </a>
                      </li>
                    </Links>
                    <hr />
                    <h2>{content.contact_form.form_title}</h2>
                    <ContactForm />
                  </React.Fragment>
                )}
              </ContactFormContainer>
            </Container>
          </Layout>
        )}
      />
    )}
  </LanguageConsumer>
)
